import React from 'react';
import { Button } from 'react-bootstrap';

interface AddAccountButtonProps {
  open: () => void;
  ready: boolean;
  linkToken: string | null;
}

const AddAccountButton: React.FC<AddAccountButtonProps> = ({ open, ready, linkToken }) => {
  return (
    <Button
      onClick={() => {
        if (linkToken) open();
      }}
      disabled={!ready || !linkToken}
      className="greenButton py-3 btn-lg mb-4"
    >
      {ready ? 'Add account ' : 'Initializing...'}
      <i className="bi bi-plus-circle"></i>
    </Button>
  );
};

export default AddAccountButton;